import React, { useState } from "react";
import { DocRenderer } from "@cyntler/react-doc-viewer";

const iconStyle: React.CSSProperties = {
  fontSize: "16px",
  fontWeight: "bold",
  lineHeight: 1,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
};

const ResetZoomPDFIcon = () => <span style={iconStyle}>100%</span>;
const ZoomInPDFIcon = () => <span style={iconStyle}>+</span>;
const ZoomOutPDFIcon = () => <span style={iconStyle}>-</span>;

const ImageRenderer: DocRenderer = ({ mainState: { currentDocument } }) => {
  const [zoom, setZoom] = useState(100);

  if (!currentDocument) return null;

  const zoomOut = () => {
    setZoom((prevZoom) => Math.max(prevZoom - 10, 10));
  };

  const zoomIn = () => {
    setZoom((prevZoom) => prevZoom + 10);
  };

  const zoomReset = () => {
    setZoom(100);
  };

  const getOpacity = () => {
    return zoom === 100 ? 0.4 : 1.0;
  };

  return (
    <div
      id="image-renderer"
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
      }}
    >
      <div className="image-renderer-controls-container">
        <a
          id="pdf-zoom-out"
          className="image-renderer-controls-button"
          onClick={zoomOut}
        >
          <ZoomOutPDFIcon />
        </a>

        <a
          id="pdf-zoom-in"
          className="image-renderer-controls-button"
          onClick={zoomIn}
        >
          <ZoomInPDFIcon />
        </a>

        <a
          id="pdf-zoom-reset"
          className="image-renderer-controls-button"
          onClick={zoomReset}
          style={{ opacity: getOpacity() }}
        >
          <ResetZoomPDFIcon />
        </a>
      </div>

      <img
        src={currentDocument.fileData}
        style={{ width: `${zoom}%` }}
        alt="document preview"
      />
    </div>
  );
};

ImageRenderer.fileTypes = ["png", "image/png", "jpg", "image/jpg"];
ImageRenderer.weight = 1;

export default ImageRenderer;